import { Module } from "../plugins/_application";

var $ = jQuery;

export default class Modalbox extends Module {

	ready(app) {

		$(document).on('click', '.isModal', function(e){

			e.preventDefault();

			$('.modalOverlay').show();
			$('.modal-container').css('display', 'flex');
			$('.modal-openings').show();

			setTimeout(function(){

				$('.modalOverlay').css('opacity', '1');

				$('.modal-openings').css('transform', 'scale(1)');
				$('.modal-openings').css('opacity', '1');

			},10);

		});

		$(document).on('click', '.modalOverlay', function(){

			$('.modal-openings').css('transform', 'scale(0.3)');
			$('.modal-openings').css('opacity', '0');

			$('.modalOverlay').css('opacity', '0');

			setTimeout(function(){

				$('.modalOverlay').hide();
				$('.modal-openings').hide();
				$('.modal-container').hide();

			},400);

		});

		$(document).on('click', '.close', function(){

			$('.modal-openings').css('transform', 'scale(0.3)');
			$('.modal-openings').css('opacity', '0');

			$('.modalOverlay').css('opacity', '0');

			setTimeout(function(){

				$('.modalOverlay').hide();
				$('.modal-openings').hide();
				$('.modal-container').hide();

			},400);

		});

    }
}